export const getLayerId = (parent: string, source: string) =>
  `${parent}::${source}`;
